"use client";
import React from 'react'
import { fontWeights } from "@/utils/fonts";
import AllIconsComponent from "../custom-icons/AllIconsComponent";

export interface AppToolItem {
  name: string;
  image: string;
  height?: string;
  width?: string;
}

export interface AppToolsProps {
  items?: AppToolItem[];
}

export function AppTools({ items = [] }: AppToolsProps) {
  const shouldScroll = items.length > 1;
  // Only double items if we are scrolling for seamless effect
  const tech = shouldScroll ? [...items, ...items] : items;

  if (items.length === 0) return null;

  return (
    <>
      <div className={`relative w-full overflow-hidden py-2 flex items-center h-[55px] tsm-400:h-[55px] sm:h-[60px] md:h-[70px] lg:h-[85px] xl:h-[100px] 2xl:h-[120px] ${!shouldScroll ? 'justify-center' : ''}`}>
        <div className={`flex w-max items-center ${shouldScroll ? 'animate-scroll hover:pause-scroll' : ''}`}>
          {tech.map((ele, index) => (
            <div
              key={index}
              className="min-w-[200px] sm:min-w-[250px] lg:min-w-[300px] px-2 sm:px-4 transition-transform duration-900 hover:scale-105"
            >
              <div className="bg-white flex items-center justify-center text-center h-[30px] sm:h-[40px] lg:h-[60px] xl:h-[70px] 2xl:h-[100px] rounded-md">
                <div className="flex-shrink-0 flex items-center justify-center h-full [&>svg]:h-[35px] tsm-400:[&>svg]:h-[35px] sm:[&>svg]:h-[40px] lg:[&>svg]:h-[60px] xl:[&>svg]:h-[70px] xl:[&>svg]:h-auto [&>svg]:w-auto">
                  {ele.image && (ele.image.startsWith('http') || ele.image.startsWith('/')) ? (
                    <img src={ele.image} alt={ele.name} className="h-full object-contain" />
                  ) : (
                    <AllIconsComponent iconName={ele.image} height={ele.height || "70"} width={ele.width || "70"} color="black" />
                  )}
                </div>
                <p className="px-3 sm:px-4 text-[16px] sm:text-[22px] lg:text-[30px] text-black whitespace-nowrap"
                  style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.medium }}
                >
                  {ele.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
